/**
 * Session type definitions for the unified session UX
 *
 * All sessions are identified by a room code and a player name.
 * The backend auto-creates sessions when joining a non-existent room code.
 */

/**
 * Configuration for a session (unified - no start/join distinction)
 */
export interface SessionConfig {
  /** Room code for this session */
  sessionCode: string;
  /** Player's display name */
  playerName: string;
}

/**
 * Metadata tracked for each session
 */
export interface SessionMetadata {
  createdAt: string;
  lastUsedAt: string;
}

/**
 * A saved session persisted to localStorage
 */
export interface SavedSession {
  id: string;
  config: SessionConfig;
  metadata: SessionMetadata;
}

/**
 * Generate a unique session ID
 *
 * @returns A unique session identifier string
 */
export function generateSessionId(): string {
  return `session-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
}

/**
 * Create initial metadata for a new session
 *
 * @returns Fresh session metadata with current timestamps
 */
export function createInitialSessionMetadata(): SessionMetadata {
  const now = new Date().toISOString();
  return {
    createdAt: now,
    lastUsedAt: now
  };
}
